// Home
import Maternidad from "../assets/icons/Maternidad.webp";
import Medicos from "../assets/icons/Medicos.webp";
import Servicios from "../assets/icons/Servicios.webp";
import Membresia from "../assets/icons/Membresia.webp";
import imagen1 from "../assets/Home/imagen1.webp";
import imagen2 from "../assets/Home/imagen2.webp";
import imagen3 from "../assets/Home/imagen3.webp";
import imagen4 from "../assets/Home/imagen4.webp";
import imagen5 from "../assets/Home/imagen5.webp";
import imagen6 from "../assets/Home/imagen6.webp";
import recurso9 from "../assets/Home/Recurso 9.png";
import recurso10 from "../assets/Home/Recurso 10.png";
import recurso11 from "../assets/Home/Recurso 11.png";
import recurso12 from "../assets/Home/Recurso 12.png";
import recurso13 from "../assets/Home/Recurso 13.png";
import recurso14 from "../assets/Home/Recurso 14.png";

// Iconos de beneficios 365
import imagenBenef1 from "../assets/Membership/Benefits/img1.png";
import imagenBenef2 from "../assets/Membership/Benefits/img2.png";
import imagenBenef3 from "../assets/Membership/Benefits/img3.png";
import imagenBenef4 from "../assets/Membership/Benefits/img4.png";
import imagenBenef5 from "../assets/Membership/Benefits/img5.png";
import imagenBenef6 from "../assets/Membership/Benefits/img6.png";

// Archivos Membresia Salud 365
import redMedicaCat from "../assets/Salud365/Catalogo red médica y de servicios.pdf";
import inscripcionMembresia from "../assets/Salud365/Solicitud de afiliación salud365.pdf";

// Iconos Planes 365
import imagenPlan1 from "../assets/Membership/Plans/icon1.png";
import imagenPlan2 from "../assets/Membership/Plans/icon2.png";
import imagenPlan3 from "../assets/Membership/Plans/icon3.png";

// Iconos de profesionales 365
import imagenProf1 from "../assets/Membership/Network/icon01.png";
import imagenProf2 from "../assets/Membership/Network/icon02.png";
import imagenProf3 from "../assets/Membership/Network/icon03.png";
import imagenProf4 from "../assets/Membership/Network/icon04.png";

// Banner Hero Slider Desktop
import HEROimagenDesktop1 from "../assets/Home/banners/desktopBanner03.png";
import HEROimagenDesktop2 from "../assets/Home/banners/desktopBanner04.png";
import HEROimagenDesktop3 from "../assets/Home/banners/desktopBanner05.png";
import HEROimagenDesktop4 from "../assets/Home/banners/desktopBanner06.png";
import HEROimagenDesktop5 from "../assets/Home/banners/desktopBanner07.png";
import HEROimagenDesktop6 from "../assets/Home/banners/desktopBanner08.png";
// import HEROimagenDesktop7 from "../assets/Home/banners/desktopBanner09.png";
// import HEROimagenDesktop8 from "../assets/Home/banners/desktopBanner10.png";
import HEROimagenDesktop9 from "../assets/Home/banners/desktopBanner11.png";
import HEROimagenDesktop10 from "../assets/Home/banners/desktopBanner12.png";
import HEROimagenDesktop11 from "../assets/Home/banners/desktopBanner13.png";

// Banner Hero Slider Mobile
import HEROimagenMobile1 from "../assets/Home/banners/mobileBanner03.png";
import HEROimagenMobile2 from "../assets/Home/banners/mobileBanner04.png";
import HEROimagenMobile3 from "../assets/Home/banners/mobileBanner05.png";
import HEROimagenMobile4 from "../assets/Home/banners/mobileBanner06.png";
import HEROimagenMobile5 from "../assets/Home/banners/mobileBanner07.png";
import HEROimagenMobile6 from "../assets/Home/banners/mobileBanner08.png";
// import HEROimagenMobile7 from "../assets/Home/banners/mobileBanner09.png";
// import HEROimagenMobile8 from "../assets/Home/banners/mobileBanner10.png";
import HEROimagenMobile9 from "../assets/Home/banners/mobileBanner11.png";
import HEROimagenMobile10 from "../assets/Home/banners/mobileBanner12.png";
import HEROimagenMobile11 from "../assets/Home/banners/mobileBanner13.png";

// Imagenes (Terminos, Politica, Acerca) para el footer.
import acerca1 from "../assets/Footer/Antecedentes01.jpg";
import acerca2 from "../assets/Footer/Antecedentes02.jpg";
import acerca3 from "../assets/Footer/Antecedentes03.jpg";
import acerca4 from "../assets/Footer/Antecedentes04.jpg";

import politica1 from "../assets/Footer/Privacidad01.jpg";
import politica2 from "../assets/Footer/Privacidad02.jpg";

import terminos1 from "../assets/Footer/Terminos001.png";
import terminos2 from "../assets/Footer/Terminos002.png";
import terminos3 from "../assets/Footer/Terminos003.png";
import terminos4 from "../assets/Footer/Terminos004.png";
import terminos5 from "../assets/Footer/Terminos005.png";
import terminos6 from "../assets/Footer/Terminos006.png";
import terminos7 from "../assets/Footer/Terminos007.png";
import terminos8 from "../assets/Footer/Terminos008.png";
import terminos9 from "../assets/Footer/Terminos009.png";
import terminos10 from "../assets/Footer/Terminos010.png";
import terminos11 from "../assets/Footer/Terminos011.png";
import terminos12 from "../assets/Footer/Terminos012.png";

// Planes modal
import beneplan1 from "../assets/Membership/Plans/planbasico.png";
import beneplan2 from "../assets/Membership/Plans/planpremium.png";

// URLS
// import TamizImagen from "../assets/Servicios/Tamiz.webp";
// import MaternindadImagen from "../assets/Servicios/Paquetes-de-maternidad.webp";
// import EsterilizacionImagen from "../assets/Servicios/Servicio-de-esterilización.webp";


// Imagenes card effects
//export const cardBasic from "../assets/Credenciales/Credencial_plan_basico_Salud_365.png";
//import cardPremium from "../assets/Credenciales/Credencial_plan_premium_Salud_365.png"

export const dataCatalogoMembresiaSalud = [
  {
    titulo: "CATÁLOGO DE RED MEDICA Y SERVICIOS 2026",
    subtitulo: "Descubra nuestro catálogo de servicios médicos y conecte con los especialistas listos para cuidar de su salud.",
    boton: "Ver catálogo completo",
    pdf: redMedicaCat,
  }
];

export const inscripcionMembresiaSalud = [
  {
    titulo: "AFILIACIÓN SALUD 365",
    subtitulo: "Completa el formulario de registro y accede a la red integral de beneficios diseñados para tu bienestar.",
    boton: "Obtener formulario ",
    pdf: inscripcionMembresia,
  }
];

// Data Home
export const dataHome = [
  {
    titulo: "Maternidad",
    subtitulo:
      "Reciba a su bebé en un espacio totalmente seguro, con la mejor atención las 24 horas.",
    url: "/servicios",
    image: Maternidad,
  },
  {
    titulo: "Servicios Médicos",
    subtitulo:
      "Más de 20 servicios médicos con tecnología de punta a su disposición.",
    url: "/servicios",
    image: Servicios,
  },
  {
    titulo: "Directorio médico",
    subtitulo:
      "Amplio staff de médicos especialistas dedicados al cuidado de su salud.",
    url: "/medicos",
    image: Medicos,
  }
  // {
  //   titulo: "Salud365",
  //   subtitulo:
  //     "Nuestra primera membresía de salud con grandes beneficios para toda la familia.",
  //   url: "/salud365",
  //   image: Membresia,
  // },
];

export const dataDetalles = [
  {
    icono: recurso9,
    cantidad: "+32",
    texto: "años de experiencia",
  },
  {
    icono: recurso10,
    cantidad: "+25",
    texto: "especialidades médicas",
  },
  {
    icono: recurso11,
    cantidad: "+20",
    texto: "servicios médicos",
  },
  {
    icono: recurso12,
    cantidad: "+100",
    texto: "médicos especialistas",
  },
  {
    icono: recurso13,
    cantidad: "+25",
    texto: "habitaciones confortables",
  },
  {
    icono: recurso14,
    cantidad: "+200",
    texto: "colaboradores capacitados",
  },
];

export const dataBeneficio = [
  {
    icono: imagenBenef1,
    texto: "Consultas gratuitas con médico general*",
  },
  {
    icono: imagenBenef2,
    texto: "Costos preferenciales en consultas de especialidad",
  },
  {
    icono: imagenBenef3,
    texto: "Descuentos en servicio de ambulancia",
  },
  {
    icono: imagenBenef4,
    texto: "Descuentos en imagenología y laboratorio",
  },
  {
    icono: imagenBenef5,
    texto: "Descuentos en hospitalización y urgencias",
  },
  {
    icono: imagenBenef6,
    texto: "¡Y muchos más beneficios!",
  },
];

export const dataPlanes = [
  {
    icono: imagenPlan1,
    texto: "Incluye 4",
    subtexto: "beneficiarios",
    cantidad: "(1)"
  },
  {
    icono: imagenPlan2,
    texto: "Único",
    subtexto: "pago anual",
    cantidad: null
  },
  {
    icono: imagenPlan3,
    texto: "Agrega",
    subtexto: "beneficiarios",
    cantidad: "(2)"
  },
];

export const dataProfesionales = [
  {
    icono: imagenProf1,
    texto: "Más de 20 especialidades médicas",
  },
  {
    icono: imagenProf2,
    texto: "Más de 40 médicos especialistas",
  },
  {
    icono: imagenProf3,
    texto: "Consultas de nutrición y psicología",
  },
  {
    icono: imagenProf4,
    texto: "Servicio de terapia física",
  },
];

// Items Home
export const itemsHome = [
  {
    url: imagen1,
  },
  {
    url: imagen2,
  },
  {
    url: imagen3,
  },
  {
    url: imagen4,
  },
  {
    url: imagen5,
  },
  {
    url: imagen6,
  },
];

// Items Banner Hero Slider
export const itemsBannerHeroSlider = [
  // {
  //   id: 7,
  //   title: "Banner 7",
  //   desktopImg: HEROimagenDesktop7,
  //   mobileImg: HEROimagenMobile7,
  // },

  // {
  //   id: 8,
  //   title: "Banner 8",
  //   desktopImg: HEROimagenDesktop8,
  //   mobileImg: HEROimagenMobile8,
  // },

  {
    id: 10,
    title: "Banner 10",
    desktopImg: HEROimagenDesktop10,
    mobileImg: HEROimagenMobile10,
  },

  {
    id: 11,
    title: "Banner 11",
    desktopImg: HEROimagenDesktop11,
    mobileImg: HEROimagenMobile11,
  },

  {
    id: 9,
    title: "Banner 9",
    desktopImg: HEROimagenDesktop9,
    mobileImg: HEROimagenMobile9,
  },
  
  {
    id: 1,
    title: "Banner 1",
    desktopImg: HEROimagenDesktop1,
    mobileImg: HEROimagenMobile1,
  },

  {
    id: 2,
    title: "Banner 2",
    desktopImg: HEROimagenDesktop2,
    mobileImg: HEROimagenMobile2,
  },

  {
    id: 3,
    title: "Banner 3",
    desktopImg: HEROimagenDesktop3,
    mobileImg: HEROimagenMobile3,
  },

  {
    id: 4,
    title: "Banner 4",
    desktopImg: HEROimagenDesktop4,
    mobileImg: HEROimagenMobile4,
  },

  {
    id: 5,
    title: "Banner 5",
    desktopImg: HEROimagenDesktop5,
    mobileImg: HEROimagenMobile5,
  },

  {
    id: 6,
    title: "Banner 6",
    desktopImg: HEROimagenDesktop6,
    mobileImg: HEROimagenMobile6,
  }
];

export const imagenesModalPlans = {
  basico: [
    { id: 1, imagen: beneplan1 },
  ],
  premium: [
    { id: 1, imagen: beneplan2 },
  ],
}

// Data Footer (Terminos y condiciones, Politicas y Privacidad, Acerca de nosotros)
export const imagenesModalFooter = {
  terminos: [
    { id: 1, imagen: terminos1 },
    { id: 2, imagen: terminos2 },
    { id: 3, imagen: terminos3 },
    { id: 4, imagen: terminos4 },
    { id: 5, imagen: terminos5 },
    { id: 6, imagen: terminos6 },
    { id: 7, imagen: terminos7 },
    { id: 8, imagen: terminos8 },
    { id: 9, imagen: terminos9 },
    { id: 10, imagen: terminos10 },
    { id: 11, imagen: terminos11 },
    { id: 12, imagen: terminos12 },
  ],
  privacidad: [
    { id: 1, imagen: politica1 },
    { id: 2, imagen: politica2 },
  ],
  acerca: [
    { id: 1, imagen: acerca1 },
    { id: 2, imagen: acerca2 },
    { id: 3, imagen: acerca3 },
    { id: 4, imagen: acerca4 },
  ],
};

// CONTACTOS

export const contactos = [
  { area: "Recepción", extension: "0 / 127 / 181" },
  { area: "Caja", extension: "162" },
  { area: "Farmacia", extension: "124" },
  { area: "Laboratorio", extension: "116" },
  { area: "Rayos X", extension: "119" },
  { area: "Resonancia", extension: "193" },
  { area: "Seguros ambulatorios", extension: "174" },
  { area: "Seguros y Convenios", extension: "126" },
];
